/**
 * Success Modal Component - Aurora Edition
 * 
 * Uses Aurora UI primitives (Card, Button, Text, Heading)
 * All styling uses design tokens from tokens.css
 */

import React from 'react';
import { Modal } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import { Text, Heading } from '../../../ui/Text';

const ModalSuccess = ({ show, handleClose }) => {
  return (
    <Modal 
      size="md" 
      className="modalSearch" 
      show={show} 
      onHide={handleClose} 
      centered
    >
      <Modal.Body className="p-0">
        <Card 
          variant="elevated" 
          padding="lg" 
          className="border-none rounded-2xl"
        >
          <div className="text-center">
            <img 
              src={`${window.location.origin}/images/Illustration.svg`}
              className="mx-auto -mb-4" 
              alt="Success illustration"
            />

            <Heading level={2} size="3xl" className="mb-2 relative z-10">
              Payment Success!
            </Heading>
            
            <Text 
              size="base" 
              color="secondary" 
              className="mb-6 relative z-10"
            >
              Thanks for your order, the order confirmation has been sent to customer@gmail.com
            </Text>

            <NavLink to="/" className="inline-block">
              <Button variant="outline" size="md" className="relative z-10">
                Back to Home
              </Button>
            </NavLink>
          </div>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default ModalSuccess;
